var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-checkbox',{attrs:{"disabled":_vm.disabled},on:{"change":_vm.changeCheck},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }